@if (mobile) {
  <nav class="wallet-mobile-nav" aria-label="Main navigation">
    @for (link of mobileLinks; track link.route) {
      <a
        [routerLink]="link.route"
        routerLinkActive="wallet-nav-active"
        ariaCurrentWhenActive="page">
        <span
          class="wallet-nav-icon"
          [ngClass]="'wallet-nav-icon-' + link.icon"
          aria-hidden="true"></span>
        {{
          link.route === '/move-money'
            ? ('wallet.navigation.move' | localise: 'Move')
            : (link.key | localise: link.label)
        }}
        @if (link.icon === 'advance' && advancePending) {
          <img
            class="wallet-nav-pending"
            src="/assets/img/icons/wallet/home/advance-pending.svg"
            alt="Advance action pending" />
        }
      </a>
    }
    <button
      type="button"
      (click)="navbarService.openMenu()"
      aria-label="More navigation">
      <span class="wallet-mobile-more" aria-hidden="true"></span>
      {{ 'wallet.navigation.more' | localise: 'More' }}
    </button>
  </nav>
} @else {
  <aside class="wallet-nav" aria-label="Main navigation">
    <div class="wallet-nav-header">
      <a
        routerLink="/wallet"
        (click)="navbarService.closeMenuIfMobile()"
        aria-label="Home">
        <img
          class="wallet-nav-logo"
          [class.wallet-nav-logo-custom]="
            !!user?.themeLogoUrl || themesService.hasCustomLogo
          "
          [src]="user?.themeLogoUrl || themesService.logoSrc"
          [attr.alt]="themesService.logoAlt || 'Logo'" />
      </a>
      @if (!navbarService.isDesktop) {
        <button
          class="wallet-nav-close"
          type="button"
          aria-label="Close navigation"
          (click)="navbarService.closeMenu()">
          ×
        </button>
      }
    </div>
    <nav class="wallet-nav-links">
      @for (link of primaryLinks; track link.route) {
        <a
          class="wallet-nav-link"
          [routerLink]="link.route"
          routerLinkActive="wallet-nav-active"
          ariaCurrentWhenActive="page"
          (click)="navbarService.closeMenuIfMobile()">
          <span
            class="wallet-nav-icon"
            [ngClass]="'wallet-nav-icon-' + link.icon"
            aria-hidden="true"></span>
          {{ link.key | localise: link.label }}
          @if (link.icon === 'advance' && advancePending) {
            <img
              class="wallet-nav-pending"
              src="/assets/img/icons/wallet/home/advance-pending.svg"
              alt="Advance action pending" />
          }
          @if (link.locked) {
            <span
              class="wallet-nav-lock"
              aria-label="Requires a Tongo account"></span>
          }
        </a>
      }
      @if (comingSoonLinks.length) {
        <a
          class="wallet-nav-link wallet-coming-soon-heading"
          routerLink="/account-preview/coming-soon"
          routerLinkActive="wallet-nav-active"
          ariaCurrentWhenActive="page"
          (click)="navbarService.closeMenuIfMobile()">
          <span
            class="wallet-nav-icon wallet-nav-icon-benefits"
            aria-hidden="true"></span>
          Coming soon
        </a>
      }
    </nav>
    <div class="wallet-nav-footer">
      @if (themesService.isBrandedTheme) {
        <p
          class="wallet-nav-powered-by"
          [style.color]="themesService.attributionColor">
          {{ 'wallet.navigation.powered_by' | localise: 'Wallet powered by' }}
          <span
            class="wallet-nav-powered-logo"
            role="img"
            aria-label="Tongo"></span>
        </p>
      }
      <button
        class="wallet-nav-profile"
        type="button"
        [matMenuTriggerFor]="profileMenu"
        aria-label="Open profile menu">
        <span class="wallet-nav-avatar" aria-hidden="true">{{ initials }}</span>
        <span class="wallet-nav-name">{{ displayName }}</span>
        <span class="wallet-nav-caret" aria-hidden="true"></span>
      </button>
    </div>
  </aside>
  <mat-menu #profileMenu="matMenu" [class]="profileMenuClass">
    <div class="wallet-profile-menu-heading">
      <strong>{{ displayName }}</strong>
      @if (user?.email) {
        <span>{{ user?.email }}</span>
      }
    </div>
    <a
      mat-menu-item
      routerLink="/settings"
      (click)="navbarService.closeMenuIfMobile()"
      ><span
        class="wallet-profile-menu-icon wallet-profile-menu-icon-settings"
        aria-hidden="true"></span
      >{{ 'settings.title' | localise: 'Settings' }}</a
    >
    <button mat-menu-item [matMenuTriggerFor]="termsMenu">
      <span
        class="wallet-profile-menu-icon wallet-profile-menu-icon-terms"
        aria-hidden="true"></span>
      {{ 'settings.terms' | localise: 'Terms' }}
    </button>
    <a
      mat-menu-item
      href="https://help.gettongo.com/en/faq"
      target="_blank"
      rel="noopener noreferrer"
      ><span
        class="wallet-profile-menu-icon wallet-profile-menu-icon-help"
        aria-hidden="true"></span
      >{{ 'settings.support' | localise: 'Support' }}</a
    >
    <button
      mat-menu-item
      class="wallet-profile-menu-logout"
      (click)="authenticationService.logout().subscribe()">
      <span
        class="wallet-profile-menu-icon wallet-profile-menu-icon-logout"
        aria-hidden="true"></span>
      {{ 'settings.logout' | localise: 'Log out' }}
    </button>
  </mat-menu>
  <mat-menu #termsMenu="matMenu" [class]="profileMenuClass">
    @if (user?.agreementSignatures?.length) {
      <a
        mat-menu-item
        routerLink="/agreement"
        (click)="navbarService.closeMenuIfMobile()">
        {{
          'left-menu.component.product_terms_and_contract_button'
            | localise: 'Product Terms & Contract'
        }}
      </a>
    }
    <a
      mat-menu-item
      href="https://gettongo.com/terms-and-conditions/"
      target="_blank"
      rel="noopener noreferrer">
      {{
        'footer.component.terms_and_conditions_link'
          | localise: 'Terms and Conditions'
      }}
    </a>
    <a
      mat-menu-item
      href="https://www.gettongo.com/data-policy"
      target="_blank"
      rel="noopener noreferrer">
      {{ 'footer.component.privacy_policy_link' | localise: 'Privacy Policy' }}
    </a>
  </mat-menu>
}
